import React from 'react';
import '../styles/ConstructionMaterialAnalysis.css';
import Badge from './Badge';

function ConstructionMaterialAnalysis(props) {
    const { constructionMaterialAnalysis, darkMode = false } = props;

    // Early return if no data
    if (!constructionMaterialAnalysis) {
        return null;
    }

    // Extract data with defaults
    const {
        analysis,
        worstMaterials = [],
        bestMaterials = []
    } = constructionMaterialAnalysis;

    // Dark mode classes
    const textColorClass = darkMode ? 'colour-white' : 'colour-primary';
    const containerClass = darkMode ? 'bg-colour-dark-mode' : 'bg-colour-white';

    return (
        <div className={`construction-material-analysis-container ${containerClass}`}>
            {/* Header Section */}
            <div className="construction-material-analysis-header-section">
                <h3 className={`heading-small-bold ${textColorClass}`}>
                    Construction material analysis
                </h3>
                {analysis && (
                    <p className={`body-regular ${textColorClass}`}>
                        {analysis.replace(/\*\*/g, '')}
                    </p>
                )}
            </div>

            {/* Main Section */}
            {(bestMaterials.length > 0 || worstMaterials.length > 0) && (
                <div className="construction-material-analysis-main-section">
                    {/* Preferred Materials Section */}
                    {bestMaterials.length > 0 && (
                        <>
                            <h4 className={`body-bold ${textColorClass}`}>
                                Preferred materials
                            </h4>
                            <div className="construction-material-analysis-review-row">
                                {bestMaterials.slice(0, 2).map((material, index) => (
                                    <Badge
                                        key={index}
                                        bgColour="bg-colour-green-01"
                                        statusDot={false}
                                        statusDotColour={null}
                                        text={material}
                                        textClass="body-regular colour-primary"
                                        icon={null}
                                        tooltip={false}
                                        tooltipBody={null}
                                        tooltipPosition={null}
                                        iconLeft={null}
                                    />
                                ))}
                            </div>
                        </>
                    )}

                    {/* Materials to Avoid Section */}
                    {worstMaterials.length > 0 && (
                        <>
                            <h4 className={`body-bold ${textColorClass}`}>
                                Material to avoid
                            </h4>
                            <div className="construction-material-analysis-review-row">
                                {worstMaterials.slice(0, 2).map((material, index) => (
                                    <Badge
                                        key={index}
                                        bgColour="bg-colour-red-01"
                                        statusDot={false}
                                        statusDotColour={null}
                                        text={material}
                                        textClass="body-regular colour-primary"
                                        icon={null}
                                        tooltip={false}
                                        tooltipBody={null}
                                        tooltipPosition={null}
                                        iconLeft={null}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default ConstructionMaterialAnalysis;

